const getOfficePhone = ({ phone }) => {
  if (!phone) {
    return '';
  }

  const phonePrepared = phone.replace(/\D/g, '');
  const isLong = phonePrepared.length > 10;

  const country = phonePrepared[0];
  const region = phonePrepared.slice(1, 4);
  return `+${country} (${region}) ${phonePrepared.slice(
    4,
    isLong ? 7 : 6
  )}-${phonePrepared.slice(
    isLong ? 7 : 6,
    isLong ? 9 : 8
  )}-${phonePrepared.slice(isLong ? 9 : 8, isLong ? 11 : 10)}`;
};

export default getOfficePhone;
